import { useImageSearchPlp } from '@/features/search/presentation/hooks/useImageSearchPlp';
import { PLP_DEFAULT_SORT, PLP_PAGE_TYPE } from '@/features/plp/constants';
import { applyImageSearchListingSeo } from '@/pages/product-listing/searchPlpListingMeta';
import { SearchPlpPageView } from '@/pages/product-listing/SearchPlpPageView';
import { useSearchPlpShell } from '@/pages/product-listing/useSearchPlpShell';

export default function ImageSearchPlpPage() {
  const { pathname, listingKey, fetchPage, tags } = useImageSearchPlp();

  const shell = useSearchPlpShell({
    pathname,
    listingKey,
    fetchPage,
    tags,
    pageType: PLP_PAGE_TYPE.IMAGE_SEARCH,
    sortBy: PLP_DEFAULT_SORT,
    mapListingMeta: applyImageSearchListingSeo,
  });

  return (
    <SearchPlpPageView
      shell={shell}
      sortBy={PLP_DEFAULT_SORT}
      plpBaseOverrides={{
        isDesktopPendingNavigation: false,
        hasBanners: false,
        hideFilterBar: true,
      }}
    />
  );
}
